import { useDispatch, useSelector } from 'react-redux'
import { useCallback, useEffect, useState } from 'react'

// antd
import {
    Pagination,
    Row,
    Space,
    Spin,
    Table,
    Tag,
    Typography,
    theme,
    Card,
    Tooltip,
} from 'antd'

// store
import { setTableData } from './store/finalReports.slice'
import './css/userReposrts.style.css'

// components
import ProfileAvatar from '../candidate/components/profil-avatar'
import UserReportsDrawer from './userReportsDrawer/userReportsDrawer'
import { ViewIcon } from '../../assets/icons'

const { Text } = Typography

const ReportUserList = () => {
    const initialState = {
        open: false,
        user: null,
    }
    const { useToken } = theme
    const { token } = useToken()
    const dispatch = useDispatch()
    const { taskLogs, isLoading, tableData } = useSelector(
        (state) => state.finalReportsSlice
    )
    const [drawerState, setDrawerState] = useState(initialState)
    const handlePageChange = (page, pageSize) => {
        dispatch(setTableData({ ...tableData, page, limit: pageSize }))
    }
    const projectColors = [
        '#4F46E5', // Indigo
        '#00C9A7', // Teal
        '#FFB020', // Amber
        '#EF4444', // Red
        '#10B981', // Emerald
        '#6366F1', // Indigo 500
        '#F59E0B', // Yellow 500
        '#3B82F6', // Blue 500
        '#8B5CF6', // Violet 500
        '#EC4899', // Pink 500
        '#F97316', // Orange 500
        '#22D3EE', // Cyan 400
        '#A855F7', // Purple 500
        '#14B8A6', // Teal 500
        '#EAB308', // Yellow 400
        '#06B6D4', // Sky 500
        '#D946EF', // Fuchsia 500
        '#FB923C', // Orange 400
        '#4ADE80', // Green 400
        '#F43F5E', // Rose 500
    ]
    // const formatTimeFromMilliseconds = (ms) => {
    //     if (!ms || isNaN(ms)) return '0'
    //     const totalSeconds = Math.floor(ms / 1000)
    //     const totalMinutes = Math.floor(totalSeconds / 60)
    //     const totalHours = Math.floor(totalMinutes / 60)
    //     const weeks = Math.floor(totalHours / 168)
    //     const days = Math.floor((totalHours % 168) / 24)
    //     const hours = totalHours % 24
    //     const minutes = totalMinutes % 60
    //     const seconds = totalSeconds % 60
    //     let result = ''
    //     if (weeks > 0) result += `${weeks}w `
    //     if (days > 0) result += `${days}d `
    //     if (hours > 0) result += `${hours}h `
    //     if (minutes > 0) result += `${minutes}m `
    //     if (seconds > 0 || result === '') result += `${seconds}s`
    //     return result.trim()
    // }
    const formatTimeFromMilliseconds = (ms) => {
        if (!ms || isNaN(ms)) return '0'

        const totalSeconds = Math.floor(ms / 1000)
        const totalMinutes = Math.floor(totalSeconds / 60)
        const totalHours = Math.floor(totalMinutes / 60)
        const minutes = totalMinutes % 60
        const seconds = totalSeconds % 60

        let result = ''
        if (totalHours > 0) result += `${totalHours}h `
        if (minutes > 0) result += `${minutes}m `
        if (seconds > 0 || result === '') result += `${seconds}s`

        return result.trim()
    }

    const getBaseTimeMs = (type, startDate, endDate) => {
        switch (type) {
            case 'day':
                return 8 * 60 * 60 * 1000 // 8 hours
            case 'week':
                return 40 * 60 * 60 * 1000 // 40 hours
            case 'month':
                return 160 * 60 * 60 * 1000 // 160 hours
            case 'custom': {
                if (!startDate || !endDate) return 0

                const start = new Date(startDate)
                const end = new Date(endDate)

                // Count days between (inclusive)
                const diffTime = end.getTime() - start.getTime()
                const totalDays =
                    Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1

                return totalDays * 8 * 60 * 60 * 1000 // 8 hours per day
            }
            default:
                return 0
        }
    }

    const columns = [
        {
            title: 'User Name',
            dataIndex: 'name',
            key: 'name',
            render: (text, item) => (
                <Space align="start" size={16}>
                    <ProfileAvatar
                        profilePicture={item?.profilePicture}
                        name={text}
                    />
                    <div>
                        <Text
                            strong
                            className="hover-underline"
                            style={{ cursor: 'pointer' }}
                            onClick={() =>
                                setDrawerState({ open: true, user: item })
                            }
                        >
                            {text || '-'}
                        </Text>
                        <br />
                        <Text type="secondary" style={{ fontSize: 12 }}>
                            {item.email || '-'}
                        </Text>
                    </div>
                </Space>
            ),
        },
        {
            title: 'Projects',
            dataIndex: 'projects',
            key: 'projects',
            render: (projects) =>
                Array.isArray(projects) && projects.length > 0 ? (
                    <Space wrap size={[8, 8]}>
                        {projects.map((data, i) => {
                            const formattedTime = formatTimeFromMilliseconds(
                                data.totalLog || 0
                            )
                            return (
                                <Tooltip
                                    key={i}
                                    title={`${formattedTime}`}
                                    placement="top"
                                >
                                    <Tag
                                        style={{
                                            fontWeight: 500,
                                            backgroundColor: 'transparent',
                                            color: '#000',
                                            borderColor: data?.colorCode
                                                ? data?.colorCode
                                                : projectColors[
                                                i % projectColors.length
                                                ],
                                            cursor: 'pointer',
                                        }}
                                    >
                                        {data?.projectName || 'N/A'}
                                    </Tag>
                                </Tooltip>
                            )
                        })}
                    </Space>
                ) : (
                    <Typography.Text type="secondary">N/A</Typography.Text>
                ),
        },
        // {
        //     title: 'Logged Time',
        //     dataIndex: 'totalLog',
        //     key: 'totalLog',
        //     render: (time) => {
        //         const formatted = time ? formatTimeFromMilliseconds(time) : '0'
        //         const maxTime = Math.max(
        //             ...taskLogs.map((log) => log.totalLog || 0)
        //         )
        //         const percent = maxTime ? (time / maxTime) * 100 : 0

        //         return (
        //             <div style={{ width: 220 }}>
        //                 <div
        //                     style={{
        //                         backgroundColor: '#DBD9FF',
        //                         borderRadius: 20,
        //                         overflow: 'hidden',
        //                         height: 10,
        //                         boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.1)',
        //                         marginBottom: 6,
        //                     }}
        //                 >
        //                     <div
        //                         style={{
        //                             width: `${percent}%`,
        //                             height: '100%',
        //                             background:
        //                                 'linear-gradient(90deg, #4F46E5, #DBD9FF)',
        //                             borderRadius: '20px',
        //                             transition:
        //                                 'width 0.8s cubic-bezier(0.4, 0, 0.2, 1)',
        //                             boxShadow:
        //                                 '0 0 4px rgba(24, 144, 255, 0.5)',
        //                             animation:
        //                                 'pulseGlow 2s infinite ease-in-out',
        //                         }}
        //                     />
        //                 </div>
        //                 <Text style={{ fontSize: 14, fontWeight: 500 }}>
        //                     {formatted}
        //                 </Text>
        //             </div>
        //         )
        //     },
        // },
        // {
        //     title: 'Logged Time',
        //     dataIndex: 'totalLog',
        //     key: 'totalLog',
        //     render: (_, item) => {
        //         const totalTime = item.totalLog || 0
        //         const formatted = formatTimeFromMilliseconds(totalTime)
        //         const maxTime = Math.max(...taskLogs.map((log) => log.totalLog || 0))
        //         const percent = maxTime ? (totalTime / maxTime) * 100 : 0

        //         const barSegments = item.projects?.map((proj, index) => {
        //             const projectPercent =
        //                 totalTime > 0 ? (proj.totalLog / totalTime) * percent : 0

        //             return (
        //                 <Tooltip
        //                     key={proj.projectId}
        //                     title={
        //                         <span>
        //                             <strong>{proj.projectName}</strong>: {formatTimeFromMilliseconds(proj.totalLog)}
        //                         </span>
        //                     }
        //                 >
        //                     <div
        //                         style={{
        //                             width: `${projectPercent}%`,
        //                             height: '100%',
        //                             cursor: "pointer",
        //                             backgroundColor: projectColors[index % projectColors.length],
        //                             transition: 'width 0.8s cubic-bezier(0.4, 0, 0.2, 1)',
        //                             borderRadius:
        //                                 index === 0
        //                                     ? '20px 0 0 20px'
        //                                     : index === item.projects.length - 1
        //                                         ? '0 20px 20px 0'
        //                                         : 0,
        //                         }}
        //                     />
        //                 </Tooltip>
        //             )
        //         })

        //         return (
        //             <div style={{ width: 220 }}>
        //                 <div
        //                     style={{
        //                         backgroundColor: '#f0f0f0',
        //                         borderRadius: 20,
        //                         overflow: 'hidden',
        //                         height: 10,
        //                         boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.1)',
        //                         marginBottom: 6,
        //                         display: 'flex',
        //                     }}
        //                 >
        //                     {barSegments}
        //                 </div>
        //                 <Text style={{ fontSize: 14, fontWeight: 500 }}>
        //                     {formatted}
        //                 </Text>
        //             </div>
        //         )
        //     },
        // }
        {
            title: 'Logged Time',
            dataIndex: 'totalLog',
            key: 'totalLog',
            render: (_, item) => {
                const totalTime = item.totalLog || 0
                const formatted = formatTimeFromMilliseconds(totalTime)
                // const EIGHT_HOURS_MS = 8 * 60 * 60 * 1000
                const BASE_TIME_MS = getBaseTimeMs(
                    tableData?.dateType,
                    tableData?.start,
                    tableData?.end
                )

                const basePercent = Math.min(
                    (totalTime / BASE_TIME_MS) * 100,
                    100
                )

                const barSegments = item.projects?.map((proj, index) => {
                    const percentOfUserTime =
                        totalTime > 0 ? proj.totalLog / totalTime : 0
                    const width = percentOfUserTime * basePercent

                    return (
                        <Tooltip
                            key={proj.projectId}
                            title={
                                <span>
                                    <strong>{proj.projectName}</strong>:{' '}
                                    {formatTimeFromMilliseconds(proj.totalLog)}
                                </span>
                            }
                        >
                            <div
                                style={{
                                    width: `${width}%`,
                                    height: '100%',
                                    backgroundColor: proj?.colorCode
                                        ? proj?.colorCode
                                        : projectColors[
                                        index % projectColors.length
                                        ],
                                    borderRadius:
                                        index === 0
                                            ? '20px 0 0 20px'
                                            : index === item.projects.length - 1
                                                ? '0 20px 20px 0'
                                                : 0,
                                    cursor: 'pointer',
                                }}
                            />
                        </Tooltip>
                    )
                })

                return (
                    <div style={{ width: 220 }}>
                        <div
                            style={{
                                backgroundColor: '#f0f0f0',
                                borderRadius: 20,
                                overflow: 'hidden',
                                height: 6,
                                display: 'flex',
                                marginBottom: 6,
                            }}
                        >
                            {barSegments}
                        </div>
                        <Text style={{ fontSize: 14, fontWeight: 500 }}>
                            {formatted}
                        </Text>
                    </div>
                )
            },
        },
        {
            title: '',
            key: 'action',
            render: (_, item) => (


                <Tooltip title="View Details">
                    <div
                        onClick={() =>
                            setDrawerState({ open: true, user: item })
                        }
                        style={{ cursor: "pointer", display: "inline-block" }}
                    >
                        <ViewIcon width={21} color={"#00000076"} />
                    </div>
                </Tooltip>
            ),
        },
    ]

    return (
        <>
            <Card
                bodyStyle={{ padding: 0 }}
                style={{
                    marginTop: 24,
                    borderRadius: 16,
                    overflow: 'hidden',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
                }}
            >
                <Spin spinning={isLoading}>
                    <Table
                        columns={columns}
                        dataSource={taskLogs}
                        pagination={false}
                        scroll={{ x: '100%' }}
                        rowKey={(record) => record._id}
                        rowClassName="hover:bg-gray-50"
                        style={{
                            borderRadius: '16px',
                        }}
                        rootClassName="tableGlobal modern-table"
                    />

                    {taskLogs?.length > 0 && (
                        <Row
                            justify="space-between"
                            align="middle"
                            style={{
                                padding: '16px 24px',
                                background: token.colorBgContainer,
                                borderTop: `1px solid ${token.colorBorder}`,
                            }}
                        >
                            <Text type="secondary">
                                Page {tableData.page} of {tableData.totalPages}{' '}
                                • {tableData.totalCount} results
                            </Text>
                            <Pagination
                                current={tableData.page}
                                pageSize={tableData.limit}
                                total={tableData.totalCount}
                                pageSizeOptions={['10', '20', '50', '100']}
                                showSizeChanger
                                onChange={handlePageChange}
                            />
                        </Row>
                    )}
                </Spin>
            </Card>
            <UserReportsDrawer
                open={drawerState.open}
                user={drawerState.user}
                setOpen={(value) =>
                    setDrawerState((prev) => ({ ...prev, open: value }))
                }
            />
        </>
    )
}

export default ReportUserList
